import { FinancialProduct } from '@app/requests/model/combos-model';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  IntervenersDigitalSignatureDTO,
  IntervenientsSignatureDTO,
  IntervenientsDTO,
  ConsentExpressRequestDTO,
  ConsentExpressDTOReturn,
  ConsentRequestDTO,
  SignatureSamlDTO,
  SignatureSAMLResponseDTO,
  startAsyncSignatureDTO,
  AccessByDevice,
  AsyncSignatureStart,
  SignatureSamlMerchantDTO,
  ThirdPartySignatureResponseDTO,
} from '@app/requests/model/logalty-signature-model';
import { Router } from '@angular/router';
import { DigitalSignatureServiceApi } from './digital-signature-service-api.service';
import { Operation, PrintContractDTO } from '@app/requests/model/requests-model';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { DigitalSignatureCommonService } from './digital-signature-common.service ';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { PrintStore } from '@app/@shared';
import { CredentialsService } from '@app/login';
import { UserType } from '@app/@core/constants/user-credentials.constants';
import { URL_REQUESTS_PARTICIPANTS_LIST } from '@app/@core/constants/routes.constants';
import { RequestsGetDataApi } from '@app/requests/requests-get-data-service/requests-get-data-api.service';
import {
  HTTP_STATUS_ERROR_ALREADY_SIGNED,
  LOGALTY_STATE_CANCELED,
  LOGALTY_STATE_REFUSED,
  LOGALTY_STATE_REFUSED_INTERVENER,
} from '@app/@core/constants/logalty-digital-signature.constants';

const ERROR_VERSION_ANDROID = 'error.version_device_android';
const ERROR_VERSION_IOS = 'error.version_device_ios';
const ERROR_UNKNOWN_DEVICE = 'error.device_unknown';
const ERROR_VERSION_DEVICE = 'error.version_device';
const ERROR_GENERIC = 'error.pagina_403';

const ALLOWED_COMARCA = [
  'TARJETA_CUENTAS_CRED',
  'TARJETA_REPSOL',
  'TARJETA_REPSOL_CG',
  'TARJETA_BONPREU',
  'PRESTAMO_CONSUMO',
  'MANGO',
  'INSTANT_CREDIT',
  'PRESTAMO_CONSUMO_IBAN',
  'BICONTRATO_REPSOL',
];

const KEY_WORD_PERJUDICADO = 'PERJUDICADO';
const ERROR_VENCIMIENTO_PERJUDICAD_CAT = 'VENCIMENT PERJUDICAT, ACTUALITZEU DATES TRUCANT AL CENTRE DE SERVEIS';

@Injectable()
export class DigitalSignatureServiceStore {
  private _SAMLdata: BehaviorSubject<SignatureSAMLResponseDTO>;
  private readonly _SamlThirdParty: BehaviorSubject<string>;

  private _cancelConsents: BehaviorSubject<boolean>;
  private _asyncSignature: BehaviorSubject<boolean>;
  private _startAsyncSignature: BehaviorSubject<AsyncSignatureStart>;

  //operation data
  private _operation: any;
  private _accesByDevice: AccessByDevice;
  private _participant: IntervenientsDTO;
  private _sessionID: string;

  private _bindOfferPrint: string;

  private _samlRequest: any;
  public isAsync: boolean = false;

  constructor(
    private translate: TranslateService,
    private router: Router,
    public dialog: MatDialog,
    public digitalSignatureCommonService: DigitalSignatureCommonService,
    private digitalSignatureServiceApi: DigitalSignatureServiceApi,
    private loaderGenericService: LoaderGenericService,
    private printStore: PrintStore,
    private credentialsService: CredentialsService,
    public requestsGetDataApi: RequestsGetDataApi
  ) {
    this._cancelConsents = new BehaviorSubject(false);
    this._asyncSignature = new BehaviorSubject(false);
    this._startAsyncSignature = new BehaviorSubject({ isConsentsStarting: false, documentResultError: undefined });
    this._SAMLdata = new BehaviorSubject(undefined);
    this._SamlThirdParty = new BehaviorSubject(undefined);
  }

  ngOnInit() {}

  public manageSignature(
    operation: Operation,
    isPrintOption: boolean,
    accessByDevice: AccessByDevice,
    cancelConsents?: boolean,
    bindOfferPrint?: string
  ) {
    localStorage.removeItem('signatureEnd');
    this.digitalSignatureCommonService.setOperation(operation);
    this.digitalSignatureCommonService.setNumOperationSignature(operation.numOperation);
    this._operation = operation;
    this._bindOfferPrint = bindOfferPrint;
    this._accesByDevice = accessByDevice;

    console.log('entra por manage signature');

    console.log('manageSignature, print: ', isPrintOption);
    console.log('operation: ', operation);

    if ((operation.noEmail || operation.noMobile) && !isPrintOption) {
      this.showDialogSignatureNoAllowed('dialog.noemail.signature.panel.title', 'dialog.noemail.signature.panel.text');
    } else {
      if (operation.signatureAllowed || isPrintOption) {
        let IntervenientsSignature: IntervenientsSignatureDTO = {
          numOperation: operation.numOperation,
          language: this.translate.currentLang,
          accessByDevice: accessByDevice ? 'S' : 'N',
          printContract: isPrintOption,
          financialProduct: operation.finacialProduct,
          nameContract: operation.comarca,
          versionContract: operation.versionImp,
          isRestructuredLoan: operation.versionContract == 'V8' && operation.finacialProduct == '15' ? 'S' : 'N',
        };

        this.isAsync = false;

        // load participants from backend service
        this.digitalSignatureServiceApi
          .getParticipantsSignature(IntervenientsSignature)
          .toPromise()
          .then(
            (data: IntervenersDigitalSignatureDTO) => {
              console.log('intervinientes: ', data);
              if (data) {
                this.digitalSignatureCommonService.setParticipantList(data);
                if (cancelConsents) this._cancelConsents.next(true);

                if (
                  data.interveners?.length === 1 &&
                  (data.notice == null || data.notice?.length === 0) &&
                  cancelConsents === false
                ) {
                  //casos 1 interviniente
                  if (data.interveners[0].document_result === LOGALTY_STATE_REFUSED) {
                    const dialogConfig = new MatDialogConfig();
                    dialogConfig.width = '90%';
                    dialogConfig.maxWidth = '550px';
                    dialogConfig.data = {
                      text: this.translate.instant('signature.dialog.refused.content'),
                      icon: undefined,
                      title: this.translate.instant('logalty.error.firmaNoPermitida'),
                    };
                    this.dialog.open(ResponseDialogComponent, dialogConfig);
                  } else {
                    if (data.interveners[0].businessCIF.length > 0) {
                      console.log('juridica');
                      //jurídica no acepta consentimientos
                      if (isPrintOption) this.printContractAfterConsentsGoPanel();
                      else this.goToSignatureLogalty(data.interveners[0], accessByDevice);
                    } else if (!isPrintOption && this.isConsentsAllowed(operation)) {
                      this.goToSignatureLogalty(data.interveners[0], accessByDevice);
                    } else {
                      //un interviniente con consentimientos aceptados
                      if (isPrintOption && data.interveners[0].consentAccepted)
                        this.printContractAfterConsentsGoPanel();
                      else this.goToConsentsLogalty(data.interveners[0], isPrintOption, accessByDevice);
                    }
                  }
                } else {
                  //casos más de un interviniente
                  if (isPrintOption) {
                    //comprobar si falta algún interviniente por aceptar consentiemientos
                    if (this.consentsAccepted(data.interveners)) {
                      this.printContractAfterConsentsGoPanel();
                    } else {
                      //en la lista de intervinientes habrá que ocultar los que ya hayan aceptado o sean jurídicos
                      this.router.navigate(
                        [
                          URL_REQUESTS_PARTICIPANTS_LIST,
                          this._operation.numOperation,
                          isPrintOption,
                          operation.comarca,
                        ],
                        {
                          replaceUrl: false,
                        }
                      );
                    }
                  } else {
                    this.router.navigate(
                      [
                        URL_REQUESTS_PARTICIPANTS_LIST,
                        this._operation.numOperation,
                        isPrintOption,
                        this._operation.comarca,
                      ],
                      {
                        replaceUrl: false,
                      }
                    );
                  }
                }
              }
            },
            (error) => {
              console.log('error pending service: ', error);
              const dialogConfig = new MatDialogConfig();

              let message: string = error.error.message;

              dialogConfig.data = {
                text: message,
                icon: 'icon-ic_circle_cross',
                buttonCancel: false,
              };

              this.dialog.open(ResponseDialogComponent, dialogConfig);
            }
          );
      } else {
        //signature not allowed
        this.showDialogSignatureNoAllowed('signature.dialog.notallowed.title', 'signature.dialog.notallowed.text');
      }
    }
  }

  private consentsAccepted(interveners: any): boolean {
    let allConsentsAccepted: boolean = true;

    interveners?.forEach((person: IntervenientsDTO) => {
      //los jurídicos no tienen que aceptar consentimientos
      if (person.consentAccepted === false && person.businessCIF === '') allConsentsAccepted = false;
    });

    return allConsentsAccepted;
  }

  public manageAsyncSignature(operation: any) {
    this.digitalSignatureCommonService.setOperation(operation);
    this.digitalSignatureCommonService.setNumOperationSignature(operation.numOperation);
    this._operation = operation;

    if (operation.signatureAllowed) {
      if (operation.noEmail || operation.noMobile) {
        this.showDialogSignatureNoAllowed(
          'dialog.noemail.signature.panel.title',
          'dialog.noemail.signature.panel.text'
        );
      } else {
        this._asyncSignature.next(true);
        this.isAsync = true;
        this.showDialogSendEmailAsync(operation.numOperation);
      }
    } else {
      //signature not allowed
      this.showDialogSignatureNoAllowed('signature.dialog.notallowed.title', 'signature.dialog.notallowed.text');
    }
  }

  public printContractAfterConsentsGoPanel() {
    console.log('operation print: ', this._operation);
    console.log('oferta vinculante print: ', this._bindOfferPrint);

    let pageOpenSignature = JSON.parse(localStorage.getItem('pageOpenSignature'));
    this.router.navigate([pageOpenSignature.url, { keepFilter: true }]);

    let printContract: PrintContractDTO = {
      bindOffer: this._bindOfferPrint,
      coBrand: this._operation.comarca,
      codeOperative: this._operation.operative,
      codeProduct: this._operation.commercialProduct,
      dateEntry: this._operation.dateEntry,
      isIne: this._operation.ine ? '' : 'S',
      language: this._operation.language,
      notary: '',
      numOperation: this._operation.numOperation,
      versionContract: this._operation.versionContract,
      versionPolicy: '',
    };

    this.printStore.printContract(printContract).then(
      (data) => {
        if (data) {
          console.log(this._operation);
          this.printStore.openPDFOnSuccess(
            data,
            this._operation.numOperation,
            this._operation.language,
            '',
            printContract,
            this._operation.legalIdentity
          );
        }
      },
      (error) => {
        this.showDialogError(error);
        console.log('error print: ', error);
      }
    );
  }

  private showDialogError(error: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';

    dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross' };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  public startAsyncSignature(encryptCode: string, accessByDevice?: AccessByDevice): any {
    this.digitalSignatureServiceApi
      .getStartAsyncSignature(encryptCode)
      .toPromise()
      .then(
        (data: startAsyncSignatureDTO) => {
          console.log('data ', data);
          if (data) {
            this.digitalSignatureCommonService.setOperation(data.operation);
            this.digitalSignatureCommonService.setNumOperationSignature(data.operation.numOperation);
            this.digitalSignatureCommonService.setDataAsynsSignatureObserver(data.consentExpress);
            this.digitalSignatureCommonService.setAssyncUserHostId(data.userHostId);

            if (
              data?.documentResult === LOGALTY_STATE_REFUSED ||
              data?.documentResult === LOGALTY_STATE_REFUSED_INTERVENER ||
              data?.documentResult === LOGALTY_STATE_CANCELED
            ) {
              this._startAsyncSignature.next({
                isConsentsStarting: false,
                documentResultError: {
                  hasDocumentResultError: true,
                  documentResult: data?.documentResult,
                },
              });
            } else {
              let operation = this.digitalSignatureCommonService.getOperation();
              if (this.isConsentsAllowed(operation)) {
                //logalty signature
                this.goToSignatureLogalty(null, accessByDevice);
              } else {
                this.digitalSignatureServiceApi
                  .getSessionDataLogalty(data.consentExpress)
                  .toPromise()
                  .then(
                    (data: ConsentExpressDTOReturn) => {
                      if (data) {
                        this.digitalSignatureCommonService.setSessionId(data.sessionID);
                        this.digitalSignatureCommonService.setSessionDataLogalty(data);
                        this._startAsyncSignature.next({ isConsentsStarting: true });
                      }
                    },
                    (error) => {
                      console.log(error);
                      this._startAsyncSignature.next({ isConsentsStarting: false });

                      const dialogConfig = new MatDialogConfig();
                      dialogConfig.data = {
                        text: error.error.message,
                        icon: 'icon-ic_circle_cross',
                        buttonCancel: false,
                      };
                      this.dialog.open(ResponseDialogComponent, dialogConfig);
                    }
                  );
              }
            }
          } else {
            this._startAsyncSignature.next({ isConsentsStarting: false });

            const dialogConfig = new MatDialogConfig();
            dialogConfig.data = {
              text: this.translate.instant('logalty.error.firmaNoPermitida'),
              icon: 'icon-ic_circle_cross',
              buttonCancel: false,
            };
            this.dialog.open(ResponseDialogComponent, dialogConfig);
          }
        },
        (error) => {
          console.log(error);
          this._startAsyncSignature.next({ isConsentsStarting: false });
          if (error.status === HTTP_STATUS_ERROR_ALREADY_SIGNED) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.width = '90%';
            dialogConfig.maxWidth = '450px';
            dialogConfig.data = {
              text: this.translate.instant('signature.dialog.alreadySigned.content'),
              icon: undefined,
              title: this.translate.instant('logalty.error.firmaNoPermitida'),
              hasButtonAccept: false,
            };
            dialogConfig.disableClose = true;
            const dialog = this.dialog.open(ResponseDialogComponent, dialogConfig);
            dialog.afterClosed().subscribe(() => window.close());
          } else {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.data = {
              text: this.translate.instant('logalty.error.firmaNoPermitida'),
              icon: 'icon-ic_circle_cross',
              buttonCancel: false,
            };
            this.dialog.open(ResponseDialogComponent, dialogConfig);
          }
        }
      );
  }

  // third party signature

  public getSAMLThirdParty(encryptCode: string): Promise<ThirdPartySignatureResponseDTO> {
    return this.digitalSignatureServiceApi.getSAMLThirdPartyFromExternalId(encryptCode).toPromise();
  }

  public SetSignFinish(encryptCode: string): Promise<boolean> {
    return this.digitalSignatureServiceApi.postSetSignFinish(encryptCode).toPromise();
  }

  startAsyncSignatureMerchant(encryptCode: string): Promise<any> {
    return this.digitalSignatureServiceApi.getStartAsyncSignatureMerchant(encryptCode).toPromise();
  }

  getSamlSignatureMerchant = (request: SignatureSamlMerchantDTO): void => {
    this.digitalSignatureServiceApi
      .getSAMLMerchantLogalty(request)
      .toPromise()
      .then(
        (data: SignatureSAMLResponseDTO) => (data ? this._SAMLdata.next(data) : null),
        (error) => {
          this.showErrorDialog(error);
        }
      );
  };

  public isConsentsAllowed(operation: Operation): boolean {
    let resp: boolean = false;
    // let brand = consentExpressService.getBrandByOperation(petition.getStrNumSol());
    switch (operation.finacialProduct) {
      case '20':
        resp = true;
        break;
      case '40':
        resp = true;
        break;
      case '10':
        if (operation.operative !== 'EIC') {
          resp = true;
        }
        break;
      case '30':
        if (operation.comarca !== 'TODAY' && operation.comarca !== 'TARJETA_BONPREU') {
          resp = true;
        }
        break;
      case '15':
        resp = true;
        break;
      default:
        break;
    }
    return resp;
  }

  public goToSignatureLogalty(participant: IntervenientsDTO, accessByDevice: AccessByDevice) {
    let dataAsyncSignature: ConsentExpressRequestDTO;
    let idDocument: string = '';
    this._operation = this.digitalSignatureCommonService.getOperation();

    // async signature
    if (!participant) {
      //TODO: test if we hace data here
      dataAsyncSignature = this.digitalSignatureCommonService.getDataAsynSignature();
      idDocument = dataAsyncSignature.idDocument;
    }

    this.loaderGenericService.showSpinner();
    let samlDTOCall: SignatureSamlDTO = {
      accessByDevice: accessByDevice ? 'S' : 'N',
      cif:
        participant && participant.businessCIF.length > 0
          ? participant.businessCIF
          : this._operation?.businessCif && this._operation?.businessCif?.length > 0
          ? this._operation.businessCif
          : '',
      documentId:
        participant && participant.businessCIF.length > 0
          ? participant.legalIdentity_id
          : participant && participant.legalIdentity_id
          ? participant.legalIdentity_id
          : idDocument,
      financialProduct: this._operation.finacialProduct,
      idCommerce: this._operation.operative,
      nameContract: this._operation.comarca,
      numOperation: this._operation.numOperation,
      contractVersion: this._operation.version,
      requestCreationDate: this._operation.dateEntry,
      establishmentId: this._operation.establishment,
      versionDevice: accessByDevice?.version,
      osDevice: accessByDevice?.os,
      userHostId: this.digitalSignatureCommonService.getAssyncUserHostId(),
      isRestructuredLoan:
        this._operation.versionContract == 'V8' && this._operation.finacialProduct == '15' ? 'S' : 'N',
    };

    this._samlRequest = samlDTOCall;

    this.digitalSignatureServiceApi
      .getSAMLLogalty(samlDTOCall)
      .toPromise()
      .then(
        (data: SignatureSAMLResponseDTO) => {
          if (data) {
            this._SAMLdata.next(data);
            if (!dataAsyncSignature) {
              this.router.navigate(['/requests/logalty-signature'], { replaceUrl: false });
            }
          }
        },
        (error) => {
          this.showErrorDialog(error);
        }
      );
  }

  private showDialogSendEmailAsync(numOperation: string) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      text: this.translate.instant('signature.async.text'),
      icon: undefined,
      title: this.translate.instant('signature.async.title'),
      buttonCancel: true,
    };

    const dialogmail = this.dialog.open(ResponseDialogComponent, dialogConfig);

    dialogmail.afterClosed().subscribe((accept: boolean) => {
      console.log('afterclose data: ', accept);
      if (accept) {
        this.sendEmailAsyncSignature(numOperation);
      }
    });
  }

  private showDialogSignatureNoAllowed(title: string, text: string) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      text: this.translate.instant(text),
      icon: undefined,
      title: this.translate.instant(title),
      buttonCancel: false,
    };

    const dialogSignature = this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  public goToConsentsLogalty(participant: IntervenientsDTO, isPrintOption: boolean, isAccessByDevice: AccessByDevice) {
    this.digitalSignatureCommonService.setParticipant(participant);
    let operation = this.digitalSignatureCommonService.getOperation();
    console.log('Go to consents method, is print option: ', isPrintOption);
    if (participant.businessCIF.length > 0) {
      isPrintOption
        ? this.printContractAfterConsentsGoPanel()
        : this.goToSignatureLogalty(participant, isAccessByDevice);
    } else {
      let consentExpress: ConsentExpressRequestDTO = {
        numRequest: operation.numOperation,
        codOperative: operation.operative,
        prodFin: operation.finacialProduct,
        email: participant.email,
        idDocument: participant.legalIdentity_id,
        language: operation.language === '' ? 'ES' : operation.language === '02' ? 'CA' : operation.language,
        name: participant.firstname,
        telephone: participant.mobile.toString(),
      };

      this.digitalSignatureServiceApi
        .getSessionDataLogalty(consentExpress)
        .toPromise()
        .then(
          (data: ConsentExpressDTOReturn) => {
            if (data) {
              this.digitalSignatureCommonService.setSessionId(data.sessionID);
              this.digitalSignatureCommonService.setSessionDataLogalty(data);
              this.router.navigate(['/requests/logalty-consents', { isPrintOption: isPrintOption }], {
                replaceUrl: true,
              });
            }
          },
          (error) => {
            console.log(error);
            const dialogConfig = new MatDialogConfig();
            dialogConfig.data = {
              text: error.error.message,
              icon: 'icon-ic_circle_cross',
              buttonCancel: false,
            };
            this.dialog.open(ResponseDialogComponent, dialogConfig);
          }
        );
    }
  }

  public sendResultConsent(result: any, isPrintOption: boolean, accessByDevice: AccessByDevice) {
    this._operation = this.digitalSignatureCommonService.getOperation();
    this._participant = this.digitalSignatureCommonService.getParticipant();
    this._sessionID = this.digitalSignatureCommonService.getSessionId();

    console.log('result consents, operation, is printoption: ', this._operation, isPrintOption);

    if (result === 'success') {
      //version contract pending to new task to get the updated version in the rest service to get consents
      //meanwhile we need to apply this workarround that was already in the current web-> this._operation.version == 0 ? 1 : this._operation.version
      //added new exceptions due to host having different contract versions, during printing it starts with the value 1, while in digital signature it has a 0
      let consentRequest: ConsentRequestDTO = {
        numRequest: this._operation.numOperation,
        codOperative: this._operation.operative,
        version:
          // AUTO Y LEASING ->
          (this._operation.version == 0 && isPrintOption) ||
          (this._operation.version == 0 && ALLOWED_COMARCA.includes(this._operation.comarca))
            ? 1
            : this._operation.version,
        language: this._operation.language === '' ? 'ES' : this._operation.language,
        publicIds: [this._sessionID],
        userHostId: this.digitalSignatureCommonService.getAssyncUserHostId(),
        printOption: isPrintOption,
        product: this._operation.finacialProduct,
      };
      this.digitalSignatureServiceApi
        .postResultConsent(consentRequest)
        .toPromise()
        .then(
          (data: any) => {
            console.log('data de consentimientos:', data);
            if (isPrintOption) {
              console.log('isPrintOption');
              //manage signature para comprobar que no quedan intervinientes por aceptar consentimientos
              //actualizamos el versionImp porque se envía en consentimientos si hay más intervinientes
              this._operation.version = data.versionImp;
              this.manageSignature(this._operation, isPrintOption, accessByDevice, false, this._bindOfferPrint);
            } else {
              this.goToSignatureLogalty(this._participant, accessByDevice);
            }
          },
          (error) => {
            console.log(error);
            this.router.navigate(['/error/403'], { replaceUrl: false });
          }
        );
    } else {
      this.digitalSignatureCommonService.setCancelConsents(true);
      this.router.navigate(
        [URL_REQUESTS_PARTICIPANTS_LIST, this._operation.numOperation, isPrintOption, this._operation.comarca],
        {
          replaceUrl: false,
        }
      );
    }
  }

  public SAMLObserver(): Observable<SignatureSAMLResponseDTO> {
    return this._SAMLdata.asObservable();
  }

  public samlthirdPartyObserver(): Observable<string> {
    return this._SamlThirdParty.asObservable();
  }

  public startAsyncSignatureObserver(): Observable<AsyncSignatureStart> {
    return this._startAsyncSignature.asObservable();
  }

  public getStartAsyncSignature(): AsyncSignatureStart {
    return this._startAsyncSignature.getValue();
  }

  public getOperationDataInstant(): Operation {
    return this._operation;
  }

  public setSAMLdata(data: SignatureSAMLResponseDTO) {
    console.log(data);
    this._SAMLdata.next(data);
  }

  public setSAMLthirdParty(data: string) {
    console.log(data);
    this._SamlThirdParty.next(data);
  }

  public getAccessByDeviceInstant(): AccessByDevice {
    return this._accesByDevice;
  }

  public sendEmailAsyncSignature(numOperation: string) {
    this.digitalSignatureServiceApi.postSendEmailAsyncSignature(numOperation).subscribe(
      (result: any) => {
        if (!result) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.data = {
            icon: null,
            buttonCancel: false,
          };
          const dialogSignature = this.dialog.open(ResponseDialogComponent, dialogConfig);
        }
      },
      (error) => {
        console.log(error);
        console.log(error.error.message);

        const dialogConfig = new MatDialogConfig();

        let message: string = error.error.message;

        dialogConfig.data = {
          text: message,
          icon: 'icon-ic_circle_cross',
          buttonCancel: false,
        };

        this.dialog.open(ResponseDialogComponent, dialogConfig);
      }
    );
  }

  private showErrorDialog(error: any) {
    if (error.error?.message) {
      let errorDescription: string = error.error.message;
      const errorText = errorDescription.includes(ERROR_VERSION_ANDROID)
        ? this.translate.instant(ERROR_VERSION_ANDROID)
        : errorDescription.includes(ERROR_VERSION_IOS)
        ? this.translate.instant(ERROR_VERSION_IOS)
        : errorDescription.includes(ERROR_UNKNOWN_DEVICE)
        ? this.translate.instant(ERROR_UNKNOWN_DEVICE)
        : errorDescription.includes(ERROR_VERSION_DEVICE)
        ? this.translate.instant(ERROR_VERSION_DEVICE)
        : error.error?.message;

      //Si no es ningún caso devolvemos el error de back/host

      const dialogConfig: MatDialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        text: errorText,
        icon: 'icon-ic_circle_cross',
      };
      this.dialog.open(ResponseDialogComponent, dialogConfig);
    } else {
      this.router.navigate(['/error/403'], { replaceUrl: true });
    }
  }

  /*
   ** [ESPSCFWMTS-4641] Due to a change of requirements this code is considered dead but it won't
   ** be removed until the EVO is confirmed to be valid.
   */
  // sendSignatureRejection = () => {
  //   return new Promise<boolean>((resolve, reject) => {
  //     const samlRequest = this._samlRequest;
  //     if (samlRequest?.financialProduct !== '20' && samlRequest?.financialProduct !== '40') {
  //       this.digitalSignatureServiceApi
  //         .postRejectSignature(this._samlRequest)
  //         .toPromise()
  //         .then(
  //           (data) => (data ? resolve(data) : reject(data)),
  //           (error) => reject(error)
  //         )
  //         .catch((error) => reject(error));
  //     } else reject(samlRequest?.financialProduct);
  //   });
  // };
}
